module.exports = ".userTable thead th p-dtcheckbox { display: none !important;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/target_user.component.css
// module id = ./src/app/component/target_user.component.css
// module chunks = main